export default __webpack_public_path__ + "static/media/news_2.e47f2e68.png";